module.exports = __webpack_public_path__ + "static/6-e398bd72b9c5d2a2848dd11d6136ed57.svg";